import { useEffect } from 'react'
import uniqid from 'uniqid'
import GitHub from '../Github/Github'
import { projects, contact } from '../../portfolio'

import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Projects.css'

function Projects() {
  const title = 'Works'

  useEffect(() => {
    document.title = title
  }, [title])


  if (!projects.length) return null

  return (
    <div className='projects'>
      <h2 className='section__title' > Projects 🎯 </h2 >

      <div className='projects__grid'>
        {projects.map((project) => (
          <ProjectContainer key={uniqid()} project={project} />
        ))}
      </div>

      <div className='project__more'>
        <a href={contact.know_more} target='__blank'>
          <span type='button' className='btn btn--outline explore'>
            explore more projects?
          </span>
        </a>
      </div>
      <GitHub />
    </div>
  )
}

export default Projects
